module.exports = __webpack_public_path__ + "img/all_exam.5b11e587.png";